<template>
	<b-container fluid class="my-2 p-2 border border-1">
		<template v-if="node">
			<b-row class="align-items-center" no-gutters>
				<b-col cols="1" style="min-height: 128px; min-width: 128px;">
					<img :src="'img/' + ((node.platform === 'unix') ? 'linux' : node.platform) + '.svg'">
				</b-col>
				<b-col class="p-2 align-self-start">
					<b-row>
						<b-col>
							<h6 class="font-weight-bold">{{ node.label || node.nodename }}</h6>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<small>
								<template v-if="(!('type' in node) || (/^(vm|aws:ec2|macstadium:orka:vm|veertu:anka:vm)$/.test(node.type)))">
									Platform: {{ node.platform | capitalize }}
									<template v-if="('ip' in node) && node.ip">
										<br/>IP: <span v-b-tooltip.hover.right title="Click to copy" @hover="$event.target.select()" @click="$copyText(node.ip)">{{ node.ip }}</span>
										<br/>State: {{ node.state | capitalize }}
<!-- 
										<br/>Connectivity: {{ node.ping || 'Offline' | capitalize }}
 -->
									</template>
								</template>
							</small>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="2">
					<template v-if="showConnect">
						<template v-for="protocol in node.protocols">
							<b-row class="py-1" no-gutters>
								<b-col>
									<b-button variant="dark" size="sm" class="btn-round text-capitalize" @click="$root.$emit('bv::show::modal', ['connectModal', node.uuid, protocol.protocol ].join('.'));" block>Connect {{ protocol.label || protocol.protocol.toUpperCase() }}</b-button>
									<b-modal :id="['connectModal', node.uuid, protocol.protocol ].join('.')" :title="'Connect to ' + (node.label || node.nodename)" ok-title="Connect" @ok="connectNode(protocol, $event)">
										<b-container class="text-center">
											<b-row>
												<b-col class="text-justify">Click <strong>Connect</strong> below to launch a {{ protocol.label }} session to <strong>{{ node.label || node.nodename }}</strong>.</b-col>
											</b-row>
											<b-row class="text-center my-4 h5">
												<b-col>Machine Information</b-col>
											</b-row>
											<b-row class="text-left">
												<b-col>
													<p>Host IP: <span v-b-tooltip.hover.right title="Click to copy" @hover="$event.target.select()" @click="$copyText(node.ip)">{{ node.ip }}</span></p>
													<p>Platform: {{ node.platform | capitalize }}</p>
													<p>Connect Method: {{ protocol.label || protocol.protocol.toUpperCase() }}</p>
												</b-col>
											</b-row>
										</b-container>
									</b-modal>
								</b-col>
							</b-row>
						</template>
					</template>
				</b-col>
			</b-row>
		</template>
		<b-row class="mh-100 align-items-center" style="min-height: 100%;" v-else no-gutters>
			<b-col>
				<elumin-loader />
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import Vue from 'vue';
	import VueClipboard from 'vue-clipboard2';
	 
	VueClipboard.config.autoSetContainer = true;
	Vue.use(VueClipboard);
	
	let listeners = [];
	
	export default
	{
		name: 'Node',
		props: { node: { type: Object, default: undefined } },
		data() { return {}; },
		computed:
		{
			isRunning: function()
			{
				return (('state' in this.node) && (this.node.state == 'running'));
			},
			showConnect: function()
			{
				if(!('type' in this.node) || this.node.type === null || (/^(vm|aws:ec2|macstadium:orka:vm|veertu:anka:vm)$/.test(this.node.type)))
					return this.isRunning;
				
				if(this.node.type == 'link')
					return true;	
			}
		},
		beforeDestroy()
		{
			listeners.forEach(
				(v) =>
				{
					console.debug('Deregistering listener: ' + v);
					
					this.$root.$off(v);
				}
			);
		},
		mounted()
		{
			let vm = this;
		},
		methods:
		{
			connectNode: function(protocol, e) 
			{
				const node = this.node;
				
				const nodeInfo = {
					node,
					protocol,
					nodeName: node.name,
					nodeHostname: node.ip,
					nodeProtocol: protocol.protocol,
					nodePlatform: node.platform,
					nodeState: node.state,
					nodeMachine: node.machine
				};
				
				let launchURL = undefined;
				
				if(!/^https?/i.test(nodeInfo.nodeProtocol))
				{
					launchURL = 'elumin://sandbox/' + btoa(JSON.stringify(nodeInfo));
					window.location = launchURL;
				}
				else
				{
					launchURL = nodeInfo.nodeProtocol + '://' + nodeInfo.nodeHostname + ':' + protocol.port;
					window.open(launchURL, nodeInfo.nodeName);
				}
				
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.btn-round
	{
		height: 30px;
		border-radius: 2em;
	}
	
	.btn-circle
	{
		width: 30px;
		height: 30px;
		border-radius: 2em;
	}
</style>
